type TeamCode = string
const TEAM_CODE_ATTRIBUTE_CLIENT_ID_SETTING_NAME = 'teamCodeAttributeClientId'

export {
  TEAM_CODE_ATTRIBUTE_CLIENT_ID_SETTING_NAME,
  TeamCode
}